import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { getToken } from "../../utilities/authHelper";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import ProductDashboard from "./ProductDashboardLink";
import { fetchProducts } from "../../utilities/AdminUtilities";
function ProductDetails() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editable, setEditable] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isCreatingNewProduct, setIsCreatingNewProduct] = useState(false);
  const [showProductDashboard, setShowProductDashboard] = useState(false);

  const [editedProduct, setEditedProduct] = useState(null);
  const handleOpenProductDashboard = (product) => {
    setSelectedProduct(product);
    setShowProductDashboard(true);
    setShowModal(false);
  };
  const handleEditChange = (e) => {
    setEditedProduct({ ...editedProduct, [e.target.name]: e.target.value });
  };
  const handleCloseProductDashboard = () => {
    setShowProductDashboard(false);
  };

  useEffect(() => {
    fetchProducts()
      .then((data) => setProducts(data))
      .catch((error) => console.error("Error fetching products:", error));
  }, []);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };
  const handleCreateNewProduct = () => {
    setIsCreatingNewProduct(true);
    setEditedProduct({});
    setShowModal(true);
    setEditable(true);
  };

  const handleSave = async () => {
    try {
      const product_name =
        editedProduct?.product_name || selectedProduct.product_name;
      const product_type =
        editedProduct?.product_type || selectedProduct.product_type;
      const product_status =
        editedProduct?.product_status || selectedProduct.product_status;
      const details_object = JSON.stringify();
      const requestBody = JSON.stringify({
        product_name,
        product_type,
        product_status,
        details_object,
      });
      var response;
      if (!isCreatingNewProduct) {
        response = await fetch(
          `${process.env.REACT_APP_API_URL}/admin/create_or_update_product?product_id=${selectedProduct.id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getToken()}`,
            },
            body: requestBody,
          }
        );
      } else {
        response = await fetch(
          `${process.env.REACT_APP_API_URL}/admin/create_or_update_product`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getToken()}`,
            },
            body: requestBody,
          }
        );
      }

      if (!response.ok) {
        throw new Error("Failed to update product");
      }
      handleCloseModal();
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error updating product:", error);
    } finally {
    }
  };
  const handleCloseModal = () => {
    setEditable(false);
    setShowModal(false);
    setIsCreatingNewProduct(false);
  };
  const handleCloseSuccessModal = () => setShowSuccessModal(false);
  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Type</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.id}>
              <td>{product.product_name}</td>
              <td>{product.product_type}</td>
              <td>{product.product_status}</td>
              <td>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => handleProductClick(product)}
                >
                  Edit
                </Button>
                <Button
                  variant="secondary"
                  size="sm"
                  className="ml-2"
                  onClick={() =>handleOpenProductDashboard(product)}
                >
                  Link Dashboard
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header>
          <Modal.Title>
            {isCreatingNewProduct
              ? "Create New Product"
              : selectedProduct?.product_name}
          </Modal.Title>
          <div>
            <i
              className="fas fa-edit p-2"
              style={{ cursor: "pointer" }}
              onClick={() => setEditable(!editable)}
            ></i>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="productId">
              <FloatingLabel controlId="productId" label="Product ID">
                <Form.Control
                  type="text"
                  name="id"
                  value={
                    isCreatingNewProduct ? "" : selectedProduct?.id || "N.A."
                  }
                  placeholder="Product ID"
                  disabled={true}
                />
              </FloatingLabel>
            </Form.Group>
            <Form.Group className="mb-3" controlId="productName">
              <FloatingLabel controlId="productName" label="Product Name">
                <Form.Control
                  type="text"
                  name="product_name"
                  value={
                    editedProduct?.product_name ||
                    (isCreatingNewProduct ? "" : selectedProduct?.product_name)
                  }
                  placeholder="Product Name"
                  onChange={handleEditChange}
                  disabled={!editable}
                />
              </FloatingLabel>
            </Form.Group>
            <Form.Group className="mb-3" controlId="productStatus">
              <FloatingLabel controlId="productStatus" label="Product Status">
                <Form.Control
                  type="text"
                  name="product_status"
                  value={
                    editedProduct?.product_status ||
                    (isCreatingNewProduct
                      ? ""
                      : selectedProduct?.product_status || "N.A.")
                  }
                  placeholder="Product Status"
                  onChange={handleEditChange}
                  disabled={!editable}
                />
              </FloatingLabel>
            </Form.Group>

            <Form.Group className="mb-3" controlId="productType">
              <FloatingLabel controlId="productType" label="Product Type">
                <Form.Control
                  type="text"
                  name="product_type"
                  value={
                    editedProduct?.product_type ||
                    (isCreatingNewProduct
                      ? ""
                      : selectedProduct?.product_type || "N.A.")
                  }
                  placeholder="Product Type"
                  onChange={handleEditChange}
                  disabled={!editable}
                />
              </FloatingLabel>
            </Form.Group>

            <Form.Group className="mb-3" controlId="createdBy">
              <FloatingLabel controlId="createdBy" label="Created By">
                <Form.Control
                  type="text"
                  name="created_by"
                  value={
                    isCreatingNewProduct
                      ? ""
                      : selectedProduct?.created_by || "N.A."
                  }
                  placeholder="Created By "
                  onChange={handleEditChange}
                  disabled={true}
                />
              </FloatingLabel>
            </Form.Group>

            <Form.Group className="mb-3" controlId="updationTimestamp">
              <FloatingLabel
                controlId="updationTimestamp"
                label="Updation Timestamp"
              >
                <Form.Control
                  type="text"
                  name="updation_timestamp"
                  value={
                    isCreatingNewProduct
                      ? ""
                      : selectedProduct?.updation_timestamp || "N.A."
                  }
                  placeholder="Updation Timestamp"
                  onChange={handleEditChange}
                  disabled={true}
                />
              </FloatingLabel>
            </Form.Group>

            {/* <Form.Group className="mb-3" controlId="detailsObject">
                  <FloatingLabel controlId="detailsObject" label="Details Object">
                    <Form.Control
                      as="textarea"
                      name="details_object"
                      value={JSON.stringify(selectedProduct?.details_object || {}, null, 2)}
                      placeholder="Details Object"
                      onChange={handleEditChange}
                      disabled={!editable}
                    />
                  </FloatingLabel>
                </Form.Group> */}

            <Form.Group className="mb-3" controlId="terminationTimestamp">
              <FloatingLabel
                controlId="terminationTimestamp"
                label="Termination Timestamp"
              >
                <Form.Control
                  type="text"
                  name="termination_timestamp"
                  value={
                    isCreatingNewProduct
                      ? ""
                      : selectedProduct?.termination_timestamp || "N.A."
                  }
                  placeholder="Termination Timestamp"
                  disabled={true}
                />
              </FloatingLabel>
            </Form.Group>

            <Form.Group className="mb-3" controlId="creationTimestamp">
              <FloatingLabel
                controlId="creationTimestamp"
                label="Creation Timestamp"
              >
                <Form.Control
                  type="text"
                  name="creation_timestamp"
                  value={
                    isCreatingNewProduct
                      ? ""
                      : selectedProduct?.creation_timestamp || "N.A."
                  }
                  placeholder="Creation Timestamp"
                  disabled={true}
                />
              </FloatingLabel>
            </Form.Group>

            {/* <Form.Group className="mb-3" controlId="productHistory">
                <FloatingLabel controlId="productHistory" label="Product History">
                  <Form.Control
                    as="textarea"
                    name="product_history"
                    value={JSON.stringify(selectedProduct?.product_history || {}, null, 2)}
                    placeholder="Product History"
                    onChange={handleEditChange}
                    disabled={!editable}
                  />
                </FloatingLabel>
              </Form.Group> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleOpenProductDashboard}>
            Link New Dashboad
          </Button>
          {editable && (
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal show={showSuccessModal} onHide={handleCloseSuccessModal} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>Your Changes have been saved successfully.</Modal.Body>
      </Modal>
      <div className="p-3 d-flex justify-content-center align-items-center">
        <Button variant="primary" onClick={handleCreateNewProduct}>
          Create New Product
        </Button>
      </div>
      {showProductDashboard && (
        <ProductDashboard
          selectedProduct={selectedProduct}
          show={showProductDashboard}
          handleClose={handleCloseProductDashboard}
        />
      )}
    </>
  );
}

export default ProductDetails;
